export default __webpack_public_path__ + "static/media/greenIcon.45220cc2.png";